import React from "react";
import { APP_STORE_URL, PLAY_STORE_URL } from "../site/constants";

export default function StoreBadges({ className = "" }) {
  return (
    <div className={`lp-store-badges ${className}`.trim()}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="lp-store-badge"
        aria-label="Download in de App Store"
      >
        <img
          src="/images/badge-app-store.svg"
          alt="Download on the App Store"
        />
      </a>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="lp-store-badge"
        aria-label="Download via Google Play"
      >
        <img
          src="/images/badge-google-play.svg"
          alt="Get it on Google Play"
        />
      </a>
    </div>
  );
}
